import { render, staticRenderFns } from "./RegionDataForm.vue?vue&type=template&id=11f6fe12&"
import script from "./RegionDataForm.controller.js?vue&type=script&lang=js&"
export * from "./RegionDataForm.controller.js?vue&type=script&lang=js&"
import style0 from "./RegionDataForm.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports